import React from "react";
// import logo from './logo.svg';
import "./StartScreen.scss";
import { addDocument } from "../WebMethods/AddDocument";
import GreenButton from "../Components/GreenButton";
import InitialFooter from "../Components/InitialFooter";
import logo from "../Images/ge-healthcare-logo.png";
import { useNavigate, Link } from "react-router";
import viewNavigate from "../Utils/viewNavigate";
import { UpdateAllDocuments } from "../WebMethods/UpdateAllDocuments";
(() => {
  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });
  // Get the value of "some_key" in eg "https://example.com/?some_key=some_value"
  let value = params.LeaderboardReset; // "some_value"
  if (value) {
    UpdateAllDocuments("answers");
  }
})();

const StartScreen = (props) => {
  let navigate = useNavigate();

  return (
    <div className="holder">
      <div className="container">
        <h1 className="title">
          SonoGenius: <br /> The Ultrasound Gaming Challenge
        </h1>
        <h2 className="subtitle">
          Test your knowledge of GE HealthCare ultrasound solutions
        </h2>
        <GreenButton
          onClick={(e) => {
            viewNavigate(navigate, "/Instruction");
          }}
        >
          Play
        </GreenButton>
        <InitialFooter logo={logo}>
          &copy; 2025 GE HealthCare. LOGIQ, Invenia are trademarks of GE
          HealthCare. Koios DS is a trademark of Koios Medical. GE is a
          trademark of General Electric Company used under trademark
          license.JB01529AFG. Commercial availability of GE HealthCare medical
          systems is subject to meeting local requirements in a given country or
          region. Contact a GE HealthCare Representative for more information.
          Intended for healthcare professionals only.
        </InitialFooter>
      </div>
    </div>
  );
};
export default StartScreen;
